import React, { useCallback } from "react";
import {
  FilterBar,
  FilterDateRange,
  FilterMultiSelect,
  FilterTimeRange,
} from "components/commons";
import { statusFilter } from "./filters";
import lang from "translations";

const BookingFilter = ({ filterState, requestState, modifyFilter, clearFilter, applyFilter }) => {
  const changeDateRangeCb = useCallback(
    (name, value) => {
      modifyFilter(name, { value });
    },
    [modifyFilter]
  );

  const clearFilterCb = useCallback(() => {
    clearFilter();
  }, [clearFilter]);

  return (
    <FilterBar
      placeholder={lang.search2}
      className="my-lg"
      filterState={filterState}
      onApply={applyFilter}
      onClear={clearFilterCb}
    >
      <FilterDateRange
        id="dateRange"
        label={lang.date}
        value={filterState.dateRange}
        onChange={(value) => changeDateRangeCb("dateRange", value)}
      />
      <FilterTimeRange
        id="timeRange"
        label={lang.timeRange}
        value={filterState.dateRange}
        onChange={(value) => modifyFilter("dateRange", { value })}
      />
      <FilterMultiSelect
        id="statusList"
        label={lang.status}
        allLabel={lang.all}
        options={statusFilter}
        value={filterState.statusList}
        onChange={(value) => modifyFilter("statusList", { value })}
      />
    </FilterBar>
  );
};

export default BookingFilter;
